module.exports = __webpack_public_path__ + "static/media/email-icon.d7aac294.svg";